import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "eye-slash_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m21.5 23-4.231-4.231-2.563-2.563-1.471-1.471L12 13.5 10.5 12l-1.235-1.235-1.47-1.47L4.92 6.42 1 2.5l1.25-1.25 4.157 4.157C7.887 4.571 9.73 4 12 4c8.5 0 11 8 11 8s-1.072 3.431-4.2 5.8l3.95 3.95L21.5 23Zm-6.005-3.505-2.579-2.579a5 5 0 0 1-5.832-5.832l-3.45-3.45C1.704 9.748 1 12 1 12s2.5 8 11 8c1.301 0 2.462-.188 3.495-.505ZM17 12a4.978 4.978 0 0 1-1 3l-1.438-1.438a3 3 0 0 0-4.124-4.124L9 8a5 5 0 0 1 8 4Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }